import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import AccordionExpand from '../Accordian';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import LinkIcon from '@mui/icons-material/Link';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';
import MessageIcon from '@mui/icons-material/Message';
import XIcon from '@mui/icons-material/X';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import Badge from '@mui/material/Badge';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ShareIcon from '@mui/icons-material/Share';
import { useMediaQuery, useTheme, Box, Tooltip } from '@mui/material';

const LargePostCard = ({
  id,
  images = [], //array of images
  title,
  summary,
  postID, //this is the actual post ID
  photoURL,
  username,
  name,
  date,
  category,
  country,
  onClick,
  vertical = '400px',
  horizontal = '800px',
  postInfo,
  navigateToCategory, // Add the navigation function prop
}) => {
  const {
    currentUser,
    setShowAlertDialog,
    setIsBookmarkForAlert,
    bookmarks, // Provide the bookmarks state
    toggleBookmark, // Provide the toggleBookmark function
  } = useAuth();

  const [currentIndex, setCurrentIndex] = useState(0); // Index for the current image
  const isBookmarked = bookmarks[postID] || false;
  const [hover, setHover] = useState(false);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md')); // breakpoints for where screen size is decided
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));

  const showPostInfo = () => {
    onClick();
    handleClose();
  };
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  //used when is bookmarked is stored in context:
  const handleBookmarkClick = () => {
    if (!currentUser) {
      setShowAlertDialog(true);
      setIsBookmarkForAlert(true);
      return;
    }
    //Info about post sent when saving bookmark to database
    toggleBookmark(postID, {
      creatorsUserId: id || null,
      title,
      summary,
      images,
      photoURL,
      username,
      //name,
      date,
      category,
      country:country || null,
      //city:city || null
    });
  };

  const handleNextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };
  const handlePrevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
  //Opens post in its own page -not using anymore becos of detailed view
  const handleClick = () => {
    navigate(`/post/${postID}`, {
      state: {
        images,
        title,
        summary,
        name,
        email,
        date,
        category,
        country,
      },
    });
  };

  //Handle navigation to username page, when it's clicked
  const handleUsernameClick = (path) => {
    navigate(path);
    setActivePath(path);
  };

  const handleShare = (platform) => {
    const postUrl = `${window.location.origin}/posts/${postID}`;
    let shareUrl = '';
    const shareText = `${title}\n\n${summary}\n\n${postUrl}`; // Including title, summary, and URL

    switch (platform) {
      case 'twitter':
        shareUrl = `https://twitter.com/share?url=${encodeURIComponent(
          postUrl
        )}&text=${encodeURIComponent(title)}`;
        break;
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          postUrl
        )}&quote=${encodeURIComponent(shareText)}`;
        break;
      case 'email':
        shareUrl = `mailto:?subject=${encodeURIComponent(
          title
        )}&body=${encodeURIComponent(shareText)}`;
        break;
        break;
      case 'message':
        shareUrl = `sms:?body=${encodeURIComponent(shareText)}`;

        break;
      case 'copy':
        navigator.clipboard.writeText(postUrl);
        alert('Link copied to clipboard!');
        return;
      default:
        break;
    }
    if (shareUrl) {
      window.open(shareUrl, '_blank', 'noopener,noreferrer');
    }
  };

  // Set height conditionally based on screen size
  const height = isMdUp && isLgUp ? vertical : '200px';
  const cardWidth = isMdUp && isLgUp ? horizontal : '320px';

  return (
    <Card
      sx={{
        maxWidth: 1500,
        width: cardWidth,
        borderRadius: 4,
        p: 1.7,
        mb: 4,
      }}
    >
      {images.length > 0 && (
        <Box position='relative'>
          <CardMedia
            component='img'
            image={images[currentIndex]}
            alt='post image'
            sx={{
              borderRadius: 3,
              objectFit: 'cover', // Ensures the image covers the area
              height: {
                xs: '240px',
                sm: '240px',
                md: height || '370px',
                lg: height || '370px',
                xl: height || '370px',
              },
              width: cardWidth,
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 6,
              right: 6,
              p: 0.5,
              width: '95%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              variant='body'
              color='black'
              sx={{
                backgroundColor: 'white',
                pl: 1,
                pr: 1,
                pt: 0.3,
                pb: 0.3,
                fontSize: { xs: 9, sm: 9, md: 9, lg: 11, xl: 11 },
                borderRadius: 3,
                ml: { lg: -1 },
                cursor: 'pointer',
                fontFamily: 'Montserrat',
              }}
              // onClick={() => handleCategoryClick(category)} // Handle category click not needed because card is used inside category
            >
              {category}
            </Typography>
            <IconButton disableRipple onClick={handleMenuClick}>
              <MoreHorizIcon
                sx={{
                  color: 'black',
                  backgroundColor: 'white',
                  p: 0.4,
                  fontSize: 15,
                  borderRadius: '50%',
                  mr: { xs: 0, sm: 0, md: 0.1, lg: 0.2, xl: 0.2 },
                }}
              />
            </IconButton>
            <Menu
              sx={{ borderRadius: 10 }}
              id='basic-menu'
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem
                sx={{ fontSize: 12, fontFamily: 'Montserrat' }}
                onClick={showPostInfo}
              >
                Detailed View
              </MenuItem>
            </Menu>
          </Box>
          {/* Arrows only show when there is more than one image */}
          {images.length > 1 && (
            <Box>
              <IconButton
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '10px',
                  transform: 'translateY(-50%)',
                  color: '#030202',
                  backgroundColor: 'white',
                  '&:hover': {
                    color: 'white',
                    backgroundColor: 'dimgrey',
                    boxShadow: '0px 2px 3px grey',
                  },
                }}
                onClick={handlePrevImage}
              >
                <ArrowBackIosIcon sx={{ fontSize: 10 }} />
              </IconButton>
              <IconButton
                sx={{
                  position: 'absolute',
                  top: '50%',
                  right: '10px',
                  transform: 'translateY(-50%)',
                  color: '#030202',
                  backgroundColor: 'white',
                  '&:hover': {
                    color: 'white',
                    backgroundColor: 'dimgrey',
                    boxShadow: '0px 2px 3px grey',
                  },
                }}
                onClick={handleNextImage}
              >
                <ArrowForwardIosIcon sx={{ fontSize: 10 }} />
              </IconButton>
            </Box>
          )}
        </Box>
      )}

      {/* Below image, all other content */}
      <CardContent
        sx={{
          margin: { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 },
          padding: { xs: 0.5, sm: 0, md: 1, lg: 1.5, xl: 1.5 },
        }}
      >
        <Box
          gap={1}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            gutterBottom
            variant='h6'
            component='div'
            sx={{
              p: 0,
              display: 'flex',
              textAlign: 'flex-start',
              fontFamily: 'Montserrat',
              maxHeight: { xs: 36, sm: 36, md: 40, lg: 55, xl: 55 },
              overflowY: 'auto',
              fontSize: { xs: 11, sm: 11, md: 14, lg: 16, xl: 16 },
              fontWeight: '600',
              '&::-webkit-scrollbar': {
                width: '8px', // Width of the scrollbar
                backgroundColor: 'transparent', // Hide scrollbar background by default
              },
              '&:hover::-webkit-scrollbar': {
                backgroundColor: '#e0e0e0', // Show the scrollbar on hover
              },
              '&:hover::-webkit-scrollbar-thumb': {
                backgroundColor: '#888', // Show the scrollbar on hover
                borderRadius: '10px', // Round the corners of the scrollbar thumb
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#555', // Darker color when hovered over the scrollbar thumb
              },
            }}
          >
            {title}
          </Typography>

          <Tooltip title={isBookmarked ? 'Unsave Post' : 'Save Post'}>
            <Badge
              // badgeContent={bookmarkCount}
              badgeContent={0}
              color='primary'
              sx={{
                '& .MuiBadge-badge': {
                  transform: 'translate(-50%, 20%)', // Adjust the percentage values as needed
                  fontSize: {
                    xs: '0.5rem',
                    sm: '0.5rem',
                    md: '0.5rem',
                    lg: '0.6rem',
                    xl: '0.6rem',
                  }, // Adjust font size
                  width: {
                    xs: '12px',
                    sm: '13px',
                    md: '15px',
                    lg: '17px',
                    xl: '17px',
                  }, // Adjust width
                  height: {
                    xs: '12px',
                    sm: '13px',
                    md: '15px',
                    lg: '17px',
                    xl: '17px',
                  }, // Adjust height
                  minWidth: {
                    xs: '10px',
                    sm: '13px',
                    md: '15px',
                    lg: '17px',
                    xl: '17px',
                  }, // Ensures the badge keeps its shape
                  color: 'white',
                  backgroundColor: 'crimson',
                  boxShadow: '1px 1px 1px grey',
                },
              }}
            >
              <IconButton disableRipple onClick={handleBookmarkClick}>
                {isBookmarked ? (
                  <BookmarkIcon
                    sx={{
                      fontSize: { xs: 20, sm: 21, md: 21, lg: 28, xl: 28 },
                      mt: 0,
                      color: 'crimson',
                    }}
                  />
                ) : (
                  <BookmarkBorderIcon
                    sx={{
                      fontSize: { xs: 20, sm: 21, md: 21, lg: 28, xl: 28 },
                      mt: 0,
                      color: 'crimson',
                      '&:hover': {
                        transform: 'scale(1.11)', // Optional: adds a slight zoom effect
                        transition:
                          'transform 0.5s ease-in-out, box-shadow 0.3s ease-in-out',
                      },
                    }}
                  />
                )}
              </IconButton>
            </Badge>
          </Tooltip>
        </Box>

        <Typography
          variant='body2'
          color='text.secondary'
          sx={{
            display: 'flex',
            textAlign: 'flex-start',
            height: { xs: images.length>0 ? 50:'auto', sm: images.length>0 ? 50:'auto', md: images.length>0 ? 60:'auto', lg: images.length>0 ? 80:'auto', xl: images.length>0 ? 80:'auto' },
            maxHeight: { xs: 250, sm: 250, md: 300, lg: 400, xl: 400 },
            overflowY: 'auto',
            fontFamily: 'Montserrat',
            
            p: { xs: 0.5, sm: 0.5, md: 1, lg: 1, xl: 1 },
            m: 0,
            ml: 0,
            mr: 0,
            mt: { xs: 0.5, sm: 0.5, md: 0.5, lg: 1, xl: 1 },
            mb: 1,
            fontSize: { xs: 11, sm: 11, md: 14, lg: 16, xl: 16 },
            whiteSpace: 'pre-line', // This will preserve line breaks and spaces
            '&:hover': {
              boxShadow: '0px 1px 2px inset grey',
              borderRadius: 2,
              cursor: 'grab',
            },
            '&::-webkit-scrollbar': {
              width: '8px', // Width of the scrollbar
              backgroundColor: 'transparent', // Hide scrollbar background by default
            },
            '&:hover::-webkit-scrollbar': {
              backgroundColor: '#e0e0e0', // Show the scrollbar on hover
            },
            '&:hover::-webkit-scrollbar-thumb': {
              backgroundColor: '#888', // Show the scrollbar on hover
              borderRadius: '10px', // Round the corners of the scrollbar thumb
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555', // Darker color when hovered over the scrollbar thumb
            },
          }}
        >
          {summary}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            mt: 1.2,
            alignItems: 'center',
          }}
        >
          <Typography
            onClick={() => handleUsernameClick(`/${username}`)}
            variant='body1'
            color='text.secondary'
            sx={{
              fontFamily: 'Montserrat',
              fontSize: { xs: 10, sm: 10, md: 10, lg: 12, xl: 12 },
              '&:hover': {
                cursor: 'pointer',
                textShadow: '0px 0px 0.5px black',
              },
            }}
          >
            {/* Posted by:{' '} */}
            {photoURL && (
              <IconButton
                // onClick={handleOpenUserMenu} - will send u to users page with all their posts
                sx={{
                  p: 0,
                }}
              >
                <Avatar
                  alt={name || 'User'}
                  src={photoURL || null}
                  sx={{
                    //border:'2px solid red',
                    width: { xs: 19, sm: 19, md: 19, lg: 25, xl: 25 },
                    height: { xs: 19, sm: 19, md: 19, lg: 25, xl: 25 },
                    mr: 0.95,
                    ml: 0.5,
                    mb: 0.2,
                    fontSize: { xs: 9, sm: 9, md: 10, lg: 10, xl: 10 },
                    bgcolor: photoURL ? 'crimson' : 'violet',
                    '&:hover': {
                      cursor: 'pointer',
                      boxShadow: '0px 0px 4px black',
                    },
                  }}
                >
                  {!photoURL && (name?.[0] || email?.[0] || 'U')}
                </Avatar>
              </IconButton>
            )}
            {username}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton onClick={() => handleShare('facebook')}>
              <FacebookIcon
                sx={{
                  color: 'blue',
                  fontSize: { xs: 22, sm: 21, md: 21, lg: 23, xl: 24 },
                }}
              />
            </IconButton>
            <IconButton onClick={() => handleShare('twitter')}>
              <XIcon
                sx={{
                  color: 'white',
                  backgroundColor: 'black',
                  fontSize: { xs: 16, sm: 16, md: 16, lg: 17, xl: 17 },
                }}
              />
            </IconButton>
            <IconButton onClick={() => handleShare('email')}>
              <EmailIcon
                sx={{
                  color: 'coral',
                  fontSize: { xs: 21, sm: 20, md: 20, lg: 21, xl: 23 },
                }}
              />
            </IconButton>
            <IconButton onClick={() => handleShare('message')}>
              <MessageIcon
                sx={{
                  color: 'green',
                  fontSize: { xs: 19, sm: 18, md: 18, lg: 19, xl: 19 },
                }}
              />
            </IconButton>
            <IconButton onClick={() => handleShare('copy')}>
              <LinkIcon
                sx={{
                  color: 'indigo',
                  fontSize: { xs: 19, sm: 18, md: 18, lg: 20, xl: 20 },
                  transform: 'rotate(-45deg)',
                }}
              />
            </IconButton>
          </Box>
        </Box>
        <AccordionExpand postId={postID} showSummary={true} />
      </CardContent>
      {/* </CardActionArea> */}
    </Card>
  );
};

export default LargePostCard;
